import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentLinks {
    export const ID = 'links';

    export interface IData extends NICmsContentComponent.IData {
        textColor?: string;
        items: ILink[];
    }

    export interface ILink {
        // line copy
        text: string;
        activeTextColor?: string;
        // tag
        tag?: string;
        // line link
        link?: string;
        // text style
        textStyle?: string;
    }
}
